import React, { useRef, useState } from "react";
import { Send } from "lucide-react";

export const InputBox = ({ onSend }) => {
  const [text, setText] = useState("");
  const inputRef = useRef(null);

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setText("");
    requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      data-testid="chat-input-box"
      className="relative z-20 flex shrink-0 items-center gap-2 px-4 py-3"
      style={{
        background: 'linear-gradient(180deg, rgba(20,14,10,0.16) 0%, rgba(20,14,10,0.02) 100%)',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <input
        ref={inputRef}
        data-testid="chat-input"
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Express your current state."
        className="flex-1 bg-transparent text-sm text-white placeholder-zinc-600 outline-none py-2.5 px-4 rounded-xl"
        style={{
          background: 'linear-gradient(180deg, rgba(39,31,24,0.9) 0%, rgba(31,25,20,0.88) 100%)',
          border: '1px solid rgba(255,255,255,0.04)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.14), inset 0 1px 0 rgba(255,255,255,0.03)',
          color: '#F1E4D3',
        }}
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
      />
      <button
        data-testid="chat-send-btn"
        type="button"
        onClick={handleSend}
        onMouseDown={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        disabled={!text.trim()}
        className="w-10 h-10 rounded-full flex items-center justify-center"
        style={{
          background: 'transparent',
          transition: 'transform 0.2s ease, opacity 0.2s ease',
          opacity: text.trim() ? 1 : 0.42,
        }}
      >
        <Send size={16} style={{ color: '#F2E6D0' }} />
      </button>
    </div>
  );
};

export default InputBox;
